<template>
    <div class="reserveFund">
        <div class="reserveFund-content">
            <!-- 财务审批 -->
            <div class="margin-top1" style="overflow: hidden;">
                <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm" label-width="100px">
                    <el-form-item label="员工" prop="employees">
                        <el-select v-model="ruleForm.employees" placeholder="选择员工">
                            <el-option
                                v-for="item in employeesList"
                                :key="item.roleId"
                                :label="item.roleName+'-'+item.userName"
                                :value="item.roleId"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="单据类型" prop="type">
                        <el-select v-model="ruleForm.type" placeholder="单据类型">
                            <el-option label="采购" value="采购"></el-option>
                            <el-option label="退件运费" v-if="this.str.type !== 3"  value="退件运费"></el-option>
                            <el-option label="备用金充值" value="备用金充值"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="开始日期" prop="starttime">
                        <el-date-picker
                            class="width1"
                            v-model="ruleForm.starttime"
                            type="date"
                            placeholder="选择开始日期"
                            @change="startDate"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="结束日期" prop="endtime">
                        <el-date-picker
                            class="width1"
                            v-model="ruleForm.endtime"
                            type="date"
                            placeholder="选择结束日期"
                            @change="endDate"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item label="单据号" prop="input" style="width: 28%;">
                        <el-input v-model="ruleForm.input" placeholder style="width: 60%;"></el-input>
                        <el-button type="primary" style="margin-left: 5px;"  class="search" @click="search2">搜索</el-button>
                        <el-button type="primary" class="search" @click="searchReset('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <div class="box">
              <span>备用金余额：{{this.balance}}</span>
            </div>
            <el-table :data="tableData" border style="width: 100%">
                <el-table-column label="单据号">
                        <template slot-scope="scope">
                            <span v-if="scope.row.firstStatus == 1">{{scope.row.receiptNumber}}</span>
                            <span v-if="scope.row.firstStatus == 2" style="color:red;">{{scope.row.receiptNumber}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单据类型">
                        <template slot-scope="scope">
                            <span v-if="scope.row.firstStatus == 1">{{scope.row.receiptType}}</span>
                            <span v-if="scope.row.firstStatus == 2" style="color:red;">{{scope.row.receiptType}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="单据金额">
                        <template slot-scope="scope">
                            <span v-if="scope.row.firstStatus == 1">{{scope.row.receiptMoney}}</span>
                            <span v-if="scope.row.firstStatus == 2" style="color:red;">{{scope.row.receiptMoney}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="余额">
                        <template slot-scope="scope">
                            <span v-if="scope.row.firstStatus == 1">{{scope.row.receiptBalance}}</span>
                            <span v-if="scope.row.firstStatus == 2" style="color:red;">{{scope.row.receiptBalance}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="时间">
                        <template slot-scope="scope">
                            <span v-if="scope.row.firstStatus == 1">{{scope.row.createTime}}</span>
                            <span v-if="scope.row.firstStatus == 2" style="color:red;">{{scope.row.createTime}}</span>
                        </template>
                    </el-table-column>
            </el-table>
            <div class="page">
                <el-pagination
                    style="margin-right:200px;"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[50, 100, 200, 400]"
                    :page-size="pagesize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { ajaxPost, Baseurl } from "../../api/api/api";
export default {
    name: "reserveFund",
    data() {
        return {
            str: "",
            employeesList: [],
            tableData: [],
            balance:"",

            currentPage: 1,
            pagesize: 50,
            size: 50,
            total: 0,

            ruleForm: {
                employees: "", //选择员工
                type: "", //单据类型
                starttime: "", //开始时间
                endtime: "", //结束时间
                input: "",
            }
        };
    },
    mounted() {},
    created() {
        this.str = JSON.parse(localStorage.getItem("role"));
        this.search();
        this.employeesAjax()
    },
    methods: {
        search2(){
            this.currentPage = 1
            this.search()
        },
        search() {
            var obj = {
                companyId:this.str.company_id,
                roleId:this.ruleForm.employees,
                startTimeString:this.ruleForm.starttime,
                endTimeString:this.ruleForm.endtime,
                receiptType:this.ruleForm.type,
                searchString:this.ruleForm.input,
                page:this.currentPage,
                size:this.size,
            };
            ajaxPost(Baseurl + "reserveFundController/selectReserveFundsByCompanyId",obj).then(res => {
                if (res.data.code == 200) {
                    this.tableData = res.data.data.pageInfo.list
                    this.total = res.data.data.pageInfo.total
                    this.balance = res.data.data.balance
                }
            });
        },
        searchReset(formName) {
            this.currentPage = 1
            this.$refs[formName].resetFields();
            this.search()
        },
        employeesAjax(){
            var obj = {
                companyId:this.str.company_id
            };
            ajaxPost(Baseurl + "reserveFundController/getRoleNameList",obj).then(res => {
                if (res.data.code == 200) {
                    this.employeesList = res.data.data
                }
            });
        },
        handleSizeChange(val) {
            this.size = val;
            this.search()
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.search()
        },
        //选择开始日期
        startDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 00:00:00";
            this.ruleForm.starttime = datetime;
        },
        //选择结束日期
        endDate(val) {
            var d = new Date(val);
            var datetime =
                d.getFullYear() +
                "-" +
                (d.getMonth() + 1) +
                "-" +
                d.getDate() +
                " 23:59:59";
            this.ruleForm.endtime = datetime;
        },
    }
};
</script>

<style lang="scss">
.reserveFund {
    width: 98%;
    margin-bottom: 50px;
    overflow: hidden;
    .reserveFund-content {
        margin-top: 20px;
        .el-form-item {
            overflow: hidden;
            width: 18%;
            margin-bottom: 18px;
            float: left;
        }
        .Reportform_tiem {
            overflow: hidden;
            border-top: 1px solid #eee;
            padding: 15px 0;
            .search-result-text {
                font-size: 14px;
                color: #606266;
                padding: 0;
            }
            .el-radio-group {
                display: inline-block;
                line-height: 1;
                vertical-align: middle;
                font-size: 0;
                margin-left: 20px;
            }
        }
        .box{
          height: 47px;
          line-height: 47px;
          border-top: 1px solid #EBEEF5;
          border-left: 1px solid #EBEEF5;
          border-right: 1px solid #EBEEF5;
        }
        .box span{
          float: right;
          padding-right: 200px;
        }
        .paging {
            width: 40%;
            margin: 20px auto;
        }
        .page {
            position: fixed;
            width: 100%;
            bottom: 0;
            background-color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 50px;
        }
    }
}
</style>
